import { Builder } from '@builder.io/sdk';

declare global {
    var _apiKeyToBuilderMap: Record<string, Builder> | undefined;
}

export const BuilderSingleton = {
    /**
     * Returns a ready-to-use Builder instance for the given API key, reusing a cached instance
     * per key instead of constructing a new one on every call. Takes no default: callers resolve
     * their own fallback key (BuilderConfig on the server, PublicConfigurationContext on the
     * client) before calling this.
     *
     * We support multiple API keys because Builder has a different API key for its drafts space.
     */
    getInstance(apiKey: string): Builder {
        global._apiKeyToBuilderMap ??= {};
        global._apiKeyToBuilderMap[apiKey] ??= createInstance(apiKey);

        return global._apiKeyToBuilderMap[apiKey];
    },
};

function createInstance(apiKey: string): Builder {
    // In the browser, `new Builder()` returns the SDK's own module-level singleton instead of a
    // fresh object whenever one already exists — silently collapsing every key onto the same
    // instance and letting the last-resolved key overwrite every earlier one's apiKey. Passing
    // forceNewInstance (the 4th constructor arg) is how the SDK itself opts out of that reuse.
    const instance = new Builder(undefined, undefined, undefined, true);
    instance.apiVersion = 'v3';
    instance.init(apiKey);
    return instance;
}
